import React from "react";
import DrawerWithFirstGraph from "./components/DrawerWithFirstGraph";
import logo from "./logo.svg";
import "./App.css";
const App = () => {
  return <DrawerWithFirstGraph />;
};

export default App;
